import { lexofficeConstants } from "./lexoffice.constants";

export function lexoffice(state = {}, action) {
    let configs;
    let i;
    switch (action.type) {
        case lexofficeConstants.GET_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST:
            return {
                ...state,
                configurationFetchLoading: true,
                errorMessage: null,
            };

        case lexofficeConstants.GET_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS:
            return {
                ...state,
                configurationFetchLoading: false,
                errorMessage: null,
                stripeLexOfficeConfigurations: action.result,
            };

        case lexofficeConstants.GET_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE:
            return {
                ...state,
                configurationFetchLoading: false,
                errorMessage: action.errorMessage,
            };

        case lexofficeConstants.UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST:
            return {
                ...state,
                updateLoading: true,
                modalErrorMessage: null,
            };

        case lexofficeConstants.UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS:
            configs = state.stripeLexOfficeConfigurations;
            if (configs) {
                i = configs.findIndex((item) => {
                    return item.externalUUID === action.result.externalUUID;
                });
                if (i > -1) {
                    configs[i] = action.result;
                } else {
                    configs.push(action.result);
                }
                if (configs) {
                    configs = configs.sort((a, b) => {
                        if (a.clientName < b.clientName) {
                            return -1;
                        }
                        if (a.clientName > b.clientName) {
                            return 1;
                        }
                        return 0;
                    });
                }
            } else {
                configs = [action.result];
            }
            return {
                ...state,
                modalErrorMessage: null,
                updateLoading: false,
                editStripeLexOfficeConfigurationModal: false,
                stripeLexOfficeConfigurations: configs,
            };

        case lexofficeConstants.UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE:
            return {
                ...state,
                updateLoading: false,
                modalErrorMessage: action.errorMessage,
            };

        case lexofficeConstants.DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST:
            return {
                ...state,
                deletionLoading: true,
                modalErrorMessage: null,
            };

        case lexofficeConstants.DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS:
            configs = state.stripeLexOfficeConfigurations;
            i = configs.findIndex((item) => {
                return item.externalUUID === action.result.externalUUID;
            });

            if (i > -1) {
                configs.splice(i, 1);
            }
            return {
                ...state,
                deletionLoading: false,
                modalErrorMessage: null,
                deletionModal: false,
                stripeLexOfficeConfigurations: configs,
            };

        case lexofficeConstants.DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE:
            return {
                ...state,
                deletionLoading: false,
                modalErrorMessage: action.errorMessage,
            };

        case lexofficeConstants.GET_LEX_OFFICE_CONNECTION_STATUS_REQUEST:
            return {
                ...state,
                connectionStatusLoading: true,
            };

        case lexofficeConstants.GET_LEX_OFFICE_CONNECTION_STATUS_SUCCESS:
            return {
                ...state,
                connectionStatusLoading: false,
                status: action.result,
            };

        case lexofficeConstants.GET_LEX_OFFICE_CONNECTION_STATUS_FAILURE:
            return {
                ...state,
                connectionStatusLoading: false,
                status: "DISCONNECTED",
            };

        case lexofficeConstants.GET_LEX_OFFICE_LOG_REQUEST:
            return {
                ...state,
                logLoading: true,
                errorMessage: null,
            };

        case lexofficeConstants.GET_LEX_OFFICE_LOG_SUCCESS:
            return {
                ...state,
                logLoading: false,
                log: action.result,
            };

        case lexofficeConstants.GET_LEX_OFFICE_LOG_FAILURE:
            return {
                ...state,
                logLoading: false,
                log: null,
                errorMessage: action.errorMessage,
            };

        case lexofficeConstants.REFRESH_LEX_OFFICE_TOKEN_REQUEST:
            return {
                ...state,
                refreshTokenLoading: true,
                errorMessage: null,
            };

        case lexofficeConstants.REFRESH_LEX_OFFICE_TOKEN_SUCCESS:
            return {
                ...state,
                refreshTokenLoading: true,
                status: action.result,
            };

        case lexofficeConstants.REFRESH_LEX_OFFICE_TOKEN_FAILURE:
            return {
                ...state,
                refreshTokenLoading: true,
                errorMessage: action.errorMessage,
            };

        case lexofficeConstants.REGISTER_LEX_OFFICE_ORGANIZATION_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };

        case lexofficeConstants.REGISTER_LEX_OFFICE_ORGANIZATION_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case lexofficeConstants.REGISTER_LEX_OFFICE_ORGANIZATION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case lexofficeConstants.TOGGLE_EDIT_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL:
            return {
                ...state,
                editStripeLexOfficeConfigurationModal: !state.editStripeLexOfficeConfigurationModal,
                modalErrorMessage: null,
            };

        case lexofficeConstants.TOGGLE_DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL:
            return {
                ...state,
                modalErrorMessage: null,
                deletionModal: !state.deletionModal,
                configurationToDelete: action.item,
            };

        default:
            return state;
    }
}
